import { JSONAPISerializer } from 'miragejs'

export default class extends JSONAPISerializer {
  typeKeyForModel(model) {
    const pluralized = super.typeKeyForModel(model)
    return pluralized.replace('book-library/', '')
  }
}
